export const PHYSICIAN_FORM_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;

export const PHYSICIAN_FORM_ACCEPTED_EXTENSIONS = [
  ".pdf",
  ".jpeg",
  ".jpg",
  ".png",
];

const ACCEPTED_MIME_TYPES = ["application/pdf", "image/jpeg", "image/png"];

export type PhysicianFormFileError = "fileType" | "fileSize";

const hasAcceptedExtension = (fileName: string): boolean => {
  const normalized = fileName.toLowerCase();
  return PHYSICIAN_FORM_ACCEPTED_EXTENSIONS.some((extension) =>
    normalized.endsWith(extension)
  );
};

export const validatePhysicianFormFile = (
  file: File
): PhysicianFormFileError | null => {
  const typeIsValid = file.type
    ? ACCEPTED_MIME_TYPES.includes(file.type)
    : hasAcceptedExtension(file.name);

  if (!typeIsValid) return "fileType";
  if (file.size > PHYSICIAN_FORM_MAX_FILE_SIZE_BYTES) return "fileSize";
  return null;
};
